export const it = {
  statModule: {
    groups: {
      examination: "Visite mediche",
    },
  },
};
